import { Button, Dialog, DialogContent, DialogTrigger } from '@/_components/ui'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'
import { CreateGuarantorDialog } from './create-guarantor-dialog'

export const CreateGuarantorButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button size="xs" className="flex items-center gap-1 font-bold text-brand-grayscale-1">
          <PlusIcon size={16} />
          Novo Avalista
        </Button>
      </DialogTrigger>
      <DialogContent
        className="min-w-[336px] max-w-[640px]"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <CreateGuarantorDialog setIsDialogOpen={setIsDialogOpen} />
      </DialogContent>
    </Dialog>
  )
}
